import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { CompanyContact } from '../../models/business/CompanyContact'
import { COMPANY_CONTACTS_URL } from '../../utils/urls'

const fetchCompanyContacts = (params: TableParams) =>
  SBAPI.FetchPaginated<CompanyContact[]>(COMPANY_CONTACTS_URL, params)

const fetchCompanyContactById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<CompanyContact>(`${COMPANY_CONTACTS_URL}/${id}`, params)

const createCompanyContact = (companyContact: CompanyContact) =>
  SBAPI.Post(COMPANY_CONTACTS_URL, companyContact)

const updateCompanyContact = (companyContact: CompanyContact) =>
  SBAPI.Put(`${COMPANY_CONTACTS_URL}/${companyContact.id}`, companyContact)

const deleteCompanyContact = (companyContact: CompanyContact) =>
  SBAPI.Delete(`${COMPANY_CONTACTS_URL}/${companyContact.id}`)

export {
  createCompanyContact,
  deleteCompanyContact,
  fetchCompanyContactById,
  fetchCompanyContacts,
  updateCompanyContact,
}
